import { NString } from '@mobalytics/shared';
import { GameConfigResult } from './game-config/game-config.types';
import { GameRegistryResult } from './game-registry/game-registry.types';

export const DYNAMIC_MODULES_COMMON_SCOPE = 'common';

export enum DynamicModuleSlug {
  GAME_CONFIG = 'game-config',
  GAME_REGISTRY = 'game-registry',
}

export interface DynamicModuleConfigJson {
  name: NString;
}

export interface DynamicModuleConfig {
  objectName: string;
  config: DynamicModuleConfigJson;
  generation: string | undefined;
}

export type DynamicModulesConfigMap = Record<string, DynamicModuleConfig>;

export type DynamicModuleContextI = {
  [DynamicModuleSlug.GAME_CONFIG]: GameConfigResult | null;
  [DynamicModuleSlug.GAME_REGISTRY]: GameRegistryResult | null;
};

export const DynamicModuleContextDefaultValue: DynamicModuleContextI = {
  [DynamicModuleSlug.GAME_CONFIG]: null,
  [DynamicModuleSlug.GAME_REGISTRY]: null,
};
